import {Table} from 'antd';
import {toFSDateTime} from "../../util/timeutils";
import {MomEventType} from "../../api/Constants";
import {MetricValueAdjust} from "./MetricValueAdjust";
import {updatePlantMetric} from "../../api/Api";

export const MomEventTable = ({events, plant, onApiFail, onRefresh}) => {
    const onAdjust = (record) => (value, date) => {
        const {id} = record;
        console.log(`adjust metric ${id} to ${value} @ ${date}`);

        updatePlantMetric(id, value, date).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const columns = [
        {
            title: 'Event',
            key: 'event',
            dataIndex: 'event',
            render: (val) => {
                return MomEventType.Label[val];
            }
        },
        {
            title: 'Data',
            key: 'data',
            dataIndex: 'data',
            render: (val, record, index) => {
                return <MetricValueAdjust value={val} date={record.date} minDate={plant.creationTime} onAdjust={onAdjust(record)}>{val}</MetricValueAdjust>
            }
        },
        {
            title: 'Notes',
            key: 'notes',
            dataIndex: 'notes'
        },
        {
            title: 'User',
            key: 'username',
            dataIndex: 'username'
        },
        {
            title: 'Date',
            key: 'date',
            dataIndex: 'date',
            render: (val) => {
                return toFSDateTime(new Date(val));
            }
        }
    ]

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <Table dataSource={events} columns={columns} pagination={tablePagination} />
}